import React, { Fragment, useContext, useEffect, useState } from "react";
import { Grid, Typography, Breadcrumbs, Link } from "@material-ui/core";

// Contexts
import StoreContext from "../../../context/stores/StoreContext";
import LayoutContext from "../../../context/layout/LayoutContext";

// Components
import StoreActions from "./StoreActions";
import StoreDisplay from "./StoreDisplay";
import Unsave from "./confirmation/Unsave";

const StoreHome = () => {
  const {
    default_form_data,
    display_content,
    stores,
    selected_store,
    form_data,
    setDisplayContent,
    getStores,
    getStore,
    clearSelectedStore,
  } = useContext(StoreContext);
  const { clearAlerts } = useContext(LayoutContext);

  const [openUnsave, setOpenUnsave] = useState(false);
  const [confirmUnsave, setConfirmUnsave] = useState(false);
  const [changeToStore, setChangeToStore] = useState("");

  const fieldsValidation = (compare_data) => {
    let changes = false;

    const list_check = [
      "status",
      "cod",
      "base_url",
      "shared_secret",
      "api_key",
      "api_secret",
      "store_name",
    ];

    for (let x in form_data) {
      if (list_check.includes(x)) {
        if (form_data[x] !== compare_data[x]) {
          changes = true;
          break;
        }
      }
    }

    return changes;
  };

  const onChangePage = (store_name) => {
    setChangeToStore(store_name);

    if (store_name) {
      const current = selected_store
        ? store_name === selected_store.store_name
        : false;

      if (!current) {
        // onStore
        // Value Checking
        let changes = false;

        if (display_content === "Create")
          changes = fieldsValidation(default_form_data);
        if (display_content === "Edit")
          changes = fieldsValidation(selected_store);

        if (changes) setOpenUnsave(true);
        else onStore(store_name);
      }
    } else {
      // onCancel
      // Value Checking
      let changes = fieldsValidation(
        selected_store ? selected_store : default_form_data
      );

      if (changes) setOpenUnsave(true);
      else onCancel();
    }
  };

  const onStore = (store_name) => {
    // Change Page - Store Selected
    store_name = store_name ? store_name : changeToStore;
    getStore(store_name);
    setDisplayContent("Edit");
    changeUrl("onStore", `/store/${store_name}`);
    clearAlerts();
  };

  const onCancel = () => {
    // Change Page - No Store Selected
    if (selected_store) clearSelectedStore();
    setDisplayContent("");
    changeUrl("onCancel", "/store");
    clearAlerts();
  };

  useEffect(() => {
    if (confirmUnsave) {
      if (changeToStore) onStore();
      else onCancel();
    }

    // Reset Variables
    setChangeToStore("");
    setOpenUnsave(false);
    setConfirmUnsave(false);
  }, [confirmUnsave]);

  const onPageLoad = () => {
    const paths = window.location.pathname.split("/");

    if (paths.length === 3) {
      if (paths[2] === "create") {
        setDisplayContent("Create");
        clearSelectedStore();
      } else {
        if (paths[2]) {
          getStore(paths[2]);
          setDisplayContent("Edit");
        }
      }
    } else setDisplayContent("");
  };

  useEffect(() => {
    getStores();

    // Load Page When Back Button Triggered
    window.addEventListener("popstate", () => onPageLoad());

    // Load Page By Url
    if (!selected_store) onPageLoad();
    // Load Page By Selected Store
    else {
      if (display_content === "Edit" || display_content === "Create") {
        setDisplayContent("Edit");
        changeUrl("onLoad", `/store/${selected_store.store_name}`);
      } else {
        setDisplayContent("");
        clearSelectedStore();
      }
    }
  }, [selected_store]);

  const changeUrl = (action, path) => {
    // console.log(action, path);

    // Append "action" to URL Without Reload
    const html = document.getElementById("root").innerHTML;
    const pageTitle = document.title;
    const urlPath = window.location.origin + path;

    window.history.pushState(
      {
        html,
        pageTitle,
      },
      "",
      urlPath
    );
  };

  return (
    <Fragment>
      <Grid container direction="row" spacing={1}>
        {" "}
        {/* Breadcrumbs */}{" "}
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h4"> Store </Typography>{" "}
          </Grid>
          <Grid item xs={12}>
            <Breadcrumbs aria-label="breadcrumb">
              {" "}
              {selected_store || display_content === "Create" ? (
                <Link color="inherit" href="/store">
                  Store{" "}
                </Link>
              ) : (
                <Link color="inherit"> Store </Link>
              )}{" "}
              {selected_store && (
                <Link color="inherit"> {selected_store.store_name} </Link>
              )}{" "}
              {display_content === "Create" && (
                <Link color="inherit"> {display_content} </Link>
              )}{" "}
            </Breadcrumbs>{" "}
          </Grid>{" "}
        </Grid>
        {stores && (
          <Fragment>
            <Unsave
              openUnsaveState={[openUnsave, setOpenUnsave]}
              setConfirmUnsave={setConfirmUnsave}
            />{" "}
            <StoreActions
              fieldsValidation={fieldsValidation}
              onChangePage={onChangePage}
              changeUrl={changeUrl}
            />{" "}
            <StoreDisplay onChangePage={onChangePage} />{" "}
          </Fragment>
        )}{" "}
      </Grid>{" "}
    </Fragment>
  );
};

export default StoreHome;
